<template>
  <div v-show="isLoaded" class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <SearchKeyWords></SearchKeyWords>
    <Classify
      class="classify"
      :class="{
        'classify-top': !$route.query.keywords,
      }"
      :items="classifyItems"
      @change="onClassifyChange"
    ></Classify>
    <List
      class="list"
      ref="list"
      url="/api/app/teacher/search/attrs"
      :search="params"
      :limit="9"
      :alwaysShowPager="true"
      @page-load="onListLoad"
    >
      <template v-slot="{ list }">
        <div class="teacher-list clearfix">
          <div
            class="teacher"
            v-for="item in list"
            :key="item.id"
            @click="onClickTeacher(item)"
          >
            <div class="avatar-wrap">
              <img class="avatar" :src="item.photo" />
            </div>
            <div class="right">
              <div class="name-wrap">
                
                <div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
                  <span class="name">{{ item.real_name }}</span>
                  <div @click.stop="zixun" class="shiting-box">
                    <svg t="1755244091537" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9254" width="14" height="14"><path d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m0 955.733333C268.8 955.733333 68.266667 755.2 68.266667 512S268.8 68.266667 512 68.266667 955.733333 268.8 955.733333 512 755.2 955.733333 512 955.733333z" fill="#ffffff" p-id="9255"></path><path d="M725.333333 469.333333l-285.866666-179.2c-25.6-17.066667-55.466667-12.8-72.533334 12.8-4.266667 8.533333-8.533333 17.066667-8.533333 29.866667v362.666667c0 29.866667 21.333333 51.2 51.2 51.2 8.533333 0 21.333333-4.266667 25.6-8.533334L725.333333 554.666667c25.6-17.066667 29.866667-46.933333 17.066667-72.533334-4.266667-4.266667-8.533333-8.533333-17.066667-12.8z" fill="#ffffff" p-id="9256"></path></svg>
                    <p>试听</p> 
                    </div>  
                </div>
                <span class="level" v-if="item.level">{{ item.level }}</span>
              </div>
              <div class="marketing_language">
                {{ item.marketing_language }}
              </div>
              <p class="introduction">{{ item.introduction }}</p>
            </div>
            <div
              class="tag"
              v-if="
                (item.level != null &&
                  $store.state.commonSetting.switch_oto_module == 1) ||
                item.is_invite_teacher == 1
              "
            ></div>
            <div class="is_consult" v-if="item.is_consult == 1"></div>
          </div>
        </div>
        <EmptyNew v-if="list.length == 0" class="empty" title="暂无讲师！" />
      </template>
    </List>
  </div>
</template>

<script>
import Classify from "../components/Classify.vue";
import List from "@/components/List.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "teacher",
  components: {
    Classify,
    List,
    SearchKeyWords,
    EmptyNew,
  },
  data() {
    return {
      attrs: [],
      attrCondition: {},
      teachers: [],
      cols: 4, // 列数
      params: {},
      isLoaded: false,
    };
  },
  computed: {
    classifyItems() {
      let items = [];
      this.attrs.forEach(c => {
        let item = {
          id: c.id,
          name: c.attr,
          value: { item: this.attrCondition[c.id] },
          children: c.value,
        };
        items.push(item);
      });
      return items;
    },
  },
  created() {
    this.requestAttr();
    this.requestData();
  },
  watch: {
    $route() {
      this.requestData(true);
    },
  },
  // mounted() {
  //   this.$kefu()
  // },
  methods: {
    zixun() {
        let scriptId = "script_floatbutton_" + 3;
        let script = document.getElementById(scriptId);
        if (script) {
          document.body.removeChild(script);
        }
        script = document.createElement("script");
        script.id = scriptId;
        document.body.append(script);
        script.innerHTML = `(function(a, b, c, d, e, j, s) {\na[d] = a[d] || function() {\n(a[d].a = a[d].a || []).push(arguments)\n};\nj = b.createElement(c),\ns = b.getElementsByTagName(c)[0];\nj.async = true;\nj.charset = 'UTF-8';\nj.src = 'https://visitor-static.meiqia.com/fe-widget-visitor/loader.js';\ns.parentNode.insertBefore(j, s);\n})(window, document, 'script', '_MEIQIA');\n_MEIQIA('entId', '0326e704d61ea2ba721c6ab65686097d');\n_MEIQIA("showPanel");`;
    },
    onListLoad() {
      this.isLoaded = true;
    },
    onClickTeacher(item) {
      this.$router.push({
        name: "ShowTeachersDetaial",
        params: {
          id: item.id,
        },
        query: {
          route_name: "ShowTeachers",
          route_label: "名师",
          title: this.$route.query.title,
          recommend: this.$route.query.recommend,
        },
      });
    },
    async requestAttr() {
      let data = await this.$http.get("/api/app/attribute/3");
      data.forEach(i => {
        i.value &&
          i.value.unshift({
            id: 0,
            name: "全部",
          });
        this.attrCondition[i.id] = 0;
      });
      this.attrs = data;
    },
    requestData(refresh = false) {
      const ary = [];
      for (const key in this.attrCondition) {
        if (this.attrCondition[key]) {
          ary.push(this.attrCondition[key]);
        }
      }
      let params = {
        attr_val_id: ary.join(),
        keywords: this.$route.query.keywords,
      };
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      this.params = params;
      if (refresh) {
        this.$refs.list.searchRefresh();
      }
    },
    onClassifyChange({ id, value }) {
      this.attrCondition[id] = value.item;
      this.requestData(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.classify-top {
  margin-top: 25px;
}
.list {
  margin-top: 25px;

  /deep/ {
    .pager {
      margin: 12px 0 46px 0;
    }
  }
}
.teacher {
  width: 384px;
  height: 208px;
  background: #fff;
  border-radius: 8px;
  float: left;
  position: relative;
  margin-top: 24px;
  margin-right: 24px;

  .shiting-box{
    padding: 4px 10px;
    background: #bb1c20;
    color: #fff;
    border-radius: 20px;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &:nth-child(3n) {
    float: left;
    margin-right: 0px;
  }
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .avatar {
      transform: scale(1.1);
    }

    .name-wrap,
    .marketing_language {
      top: -5px;
    }

    .introduction {
      top: 5px;
      cursor: pointer;
    }
    .introduction:hover {
       text-decoration: underline;
    }
  }

  .right {
    padding: 20px;
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: calc(100% - 150px);
  }

  .avatar-wrap {
    width: 150px;
    height: 180px;
    float: left;
    overflow: hidden;
    border-radius: 8px 0 0 8px;

    .avatar {
      width: 100%;
      height: 100%;
      transition: all 0.3s;
    }
  }

  .name-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    overflow: hidden;
    position: relative;
    top: 0;
    transition: top 0.3s;
  }

  .name {
    font-size: 18px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.2;
  }

  .level {
    padding: 0 9px;
    height: 24px;
    box-sizing: border-box;
    background: rgba(237, 240, 247, 0);
    border: 1px solid rgba(202, 157, 59, 1);
    border-radius: 5px;
    line-height: 22px;
    font-size: 12px;
    color: rgba(213, 169, 75, 1);
    margin-left: 11px;
    flex-shrink: 0;
  }

  .marketing_language {
    height: 15px;
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 1;
    position: relative;
    top: 0;
    transition: top 0.3s;
  }

  .line {
    width: 24px;
    height: 2px;
    background: #ededed;
    border-radius: 1px;
    margin-top: 14px;
  }

  .introduction {
    height: 100px;
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 24px;
    margin-top: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    position: relative;
    top: 0;
    transition: top 0.3s;
  }
  .is_consult {
    position: absolute;
    width: 48px;
    height: 22px;
    background-image: url("~@/assets/images/oto/zixun.png");
    background-size: 100% 100%;
    font-size: 14px;
    color: white;
    line-height: 22px;
    box-sizing: border-box;
    padding-left: 15px;
    top: 0px;
    left: 0px;
  }

  .tag {
    position: absolute;
    width: 48px;
    height: 22px;
    background-image: url("~@/assets/images/oto/tea-tag@2x.png");
    background-size: 100% 100%;
    font-size: 12px;
    color: white;
    line-height: 22px;
    box-sizing: border-box;
    padding-left: 15px;
    top: 0;
    left: 100px;
  }
}
</style>
